<div class="dropzone" (click)="close()">
  <p class="close">بستن</p>
</div>
<div class="popup">
  <p class="title">تخفیف ویژه کاربران جدید</p>
  <p class="subject">فرصت محدود برای خرید اشتراک بنتو</p>

  <div class="btn-wrapper">
    <div class="button" (click)="goShop()">اطلاعات بیشتر</div>
  </div>
  <img src="assets/general/gift.svg" alt="" />
</div>
